import React from 'react';
import FieldSingleAddress from '../common/FieldSingleAddress';
import FieldLocation from '../common/FieldLocation';

class PropertyAddressDetails extends React.Component {
  
  handleLocationChange = (id, locationData) => {
    
    // Update location field
    this.props.onValueChange(id, locationData);
    
    // Also update address field with the location data
    if (locationData && typeof locationData === 'object') {
      const addressData = [{
        street: locationData.street || '',
        city: locationData.city ? locationData.city.value : 0,
        state: locationData.state ? locationData.state.value : 0,
        country: locationData.country ? locationData.country.value : 0,
        pin: locationData.pin || ''
      }];
      
      this.props.onValueChange('address', addressData);
    }
  }

  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    
    return (
      <>
        <FieldSingleAddress key="address" id="address" field={fields.address} value={property.address} onValueChange={onValueChange} inValid={this.props.inValid}
        locationField={{ field: fields.location, value: property.location, onValueChange: this.handleLocationChange }}/>
      </>
    );
  }
}

export default PropertyAddressDetails;